export default __webpack_public_path__ + "static/media/event_preview.4de6cf1c.png";